import React from 'react';
import { View, StyleSheet } from 'react-native';
import { __WEB__ } from '../../../constants/styles';
import {
  OPComponent,
  I18n,
  Utils,
  DatePicker,
  Select,
  FormInput,
  PhoneInput,
  FormHelpers,
} from '../../components';

import moment from 'moment';

import { VA_ADMIN_CHAP, VA_PROVIDER, MED_RECRUITER } from '../../../constants/patientRoles';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const fullNameRef = React.createRef();
const emailRef = React.createRef();
const phoneRef = React.createRef();
const birthdayRef = React.createRef();
const startDateRef = React.createRef();
const statusRef = React.createRef();
const roleRef = React.createRef();
const regionRef = React.createRef();
const clinicalLocationRef = React.createRef();

function _optionReducer(result, current) {
  result.push({
    label: current,
    id: current,
  });
  return result;
}
const statuss = [VA_PROVIDER, VA_ADMIN_CHAP, MED_RECRUITER];
const statusOptions = statuss.reduce(_optionReducer, []);
const statussProviderOnly = [VA_PROVIDER, VA_ADMIN_CHAP];
const statusOptionsProviderOnly = statussProviderOnly.reduce(_optionReducer, []);

class CreatePersonFormMR extends OPComponent {
  constructor(props) {
    super(props);
    const patient = props.patient;

    // need to get this from the schedule
    const startDate = null;

    this.state = {
      fullName: patient?.fullName || null,
      email: patient?.email || null,
      phone: patient?.phone || null,
      birthday: patient?.birthDate
        ? moment(patient?.birthDate).toDate()
        : moment().subtract(17, 'years').toDate(),
      startDate: __WEB__ ? null : new Date(),
      status: patient?.role || (props.staffOnly ? MED_RECRUITER : VA_PROVIDER),
      role: null,
      clinicalLocation: props.clinicalLocation || null,
      region: props.region || null,
      step: 1,
      singlePagePatientForm: !!props.singlePagePatientForm,
    };

    this.handleInput = {};
    this.handleInput.fullName = (text) => this.handleChange('fullName', text);
    this.handleInput.email = (text) => this.handleChange('email', text);
    this.handleInput.phone = (text) => this.handleChange('phone', text);
    this.handleInput.birthday = (date) => {
      if (date) this.setState({ birthday: new Date(date) });
    };
    this.handleInput.startDate = (date) => {
      if (date) this.setState({ startDate: new Date(date) });
    };
    this.handleInput.status = ({ id }) => this.handleChangeStatus(id);
    this.handleInput.region = (region) => this.handleChangeRegion(region);
    this.handleInput.role = ({ id }) => this.handleChange('role', id);
    this.handleInput.clinicalLocation = (clinicalLocation) =>
      this.handleChangeObj('clinicalLocation', clinicalLocation);

    this.setFocus = {};
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.singlePagePatientForm && this.state.step !== prevState.step) {
      this.props.onStepChange?.(this.state.step);
    }
  }

  handleChange(stateAttrName, _text) {
    // make sure it's a string and trim any trailing whitespace
    let text = `${_text}`;
    text = text.trim();
    this.setState({ [stateAttrName]: text });
  }

  handleChangeStatus(status) {
    this.setState({ status });
  }
  handleChangeObj(key, val) {
    this.setState({ [key]: val });
  }
  handleChangeRegion(region) {
    this.setState({ region, clinicalLocation: null });
  }

  getSubmitObj = () => {
    const requestObj = {
      email: this.state.email?.toLowerCase(),
      name: this.state.fullName,
      role: this.state.role,
      clinical_location_id: this.state.clinicalLocation?.id,
      phone: this.state.phone,
      birthDate: moment(this.state.birthday).format('YYYY-MM-DD'),
      patientRole: this.state.status,
      startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
    };

    return requestObj;
  };

  _validateStep1() {
    const fieldsToValidate = [
      fullNameRef.current,
      emailRef.current,
      phoneRef.current,
      birthdayRef.current,
      startDateRef.current,
      regionRef.current,
      clinicalLocationRef.current,
    ];

    const isValid = FormHelpers.validateFields(fieldsToValidate);
    return isValid;
  }

  _validateStep2() {
    const fieldsToValidate = [];
    if (clinicalLocationRef.current) fieldsToValidate.push(clinicalLocationRef.current);

    const isValid = FormHelpers.validateFields(fieldsToValidate);
    return isValid;
  }

  // Used for single page patient form only. See case_fields.js.
  validate() {
    return this._validateStep1();
    // return this._validateStep1() && this._validateStep2();
  }

  // return false if the form failed validation
  submit = () => {
    if (!this.state.singlePagePatientForm) {
      // if (this.state.step === 1) {
      //   if (!this._validateStep1()) {
      //     return false;
      //   }
      //   if (this.timeToSubmit()) {
      //     return this.getSubmitObj();
      //   } else {
      //     this.setState({ step: 2 });
      //   }
      // } else {
      //   if (!this._validateStep2()) {
      //     return false;
      //   }
      //   return this.getSubmitObj();
      // }
    } else {
      if (!this.validate()) {
        return false;
      }
      return this.getSubmitObj();
    }
    return null;
  };
  prev = () => {
    this.setState({
      step: 1,
    });
  };

  timeToSubmit() {
    return this.state.step === 2;
  }

  renderStep1() {
    const props = this.props;
    if (!this.state.singlePagePatientForm && this.state.step !== 1) return null;
    const showProviderFields = !props.staffOnly && this.state.status !== MED_RECRUITER;
    return (
      <>
        <FormInput
          ref={fullNameRef}
          value={this.state.fullName}
          label={I18n.ac('auth.name')}
          required={true}
          onChangeText={this.handleInput.fullName}
        />
        {!props.omittedFields?.includes('email') && (
          <FormInput
            ref={emailRef}
            value={this.state.email}
            label={I18n.ac('form.emailAddress')}
            required={true}
            validateFunc={Utils.validate.email}
            invalidText={I18n.t('form.emailInvalid')}
            onChangeText={this.handleInput.email}
          />
        )}
        <PhoneInput
          ref={phoneRef}
          value={this.state.phone}
          label={I18n.ac('auth.mobilePhone')}
          required={true}
          invalidText={I18n.t('form.phoneInvalid')}
          onChangeText={this.handleInput.phone}
        />
        <DatePicker
          style={{ flex: 1 }}
          ref={birthdayRef}
          label={I18n.ac('patient.birthday')}
          validateFunc={Utils.validate.birthDate}
          required={true}
          onDate={this.handleInput.birthday}
          selectedDate={this.state.birthday}
          mode="date"
        />

        {!!showProviderFields && (
          <>
            {!props.patient && (
              <DatePicker
                style={{ flex: 1 }}
                ref={startDateRef}
                label={I18n.ac('medRecruiter.startDate')}
                validateFunc={Utils.validate.date}
                required={true}
                onDate={this.handleInput.startDate}
                selectedDate={this.state.startDate}
                mode="date"
              />
            )}
            <Select
              ref={statusRef}
              required={true}
              editable={true}
              closeOnSelect={true}
              options={statusOptionsProviderOnly}
              label={I18n.ac('airforce.status')}
              value={
                this.state.status
                  ? {
                      label: this.state.status,
                      id: this.state.status,
                    }
                  : null
              }
              onValue={this.handleInput.status}
              webMode={true}
            />
            <Select
              ref={regionRef}
              required={true}
              editable={true}
              closeOnSelect={true}
              options={props.regionOptions}
              label={I18n.ac('medRecruiter.region')}
              value={this.state.region || null}
              onValue={this.handleInput.region}
              webMode={true}
            />
            <Select
              ref={clinicalLocationRef}
              required={true}
              editable={true}
              closeOnSelect={true}
              options={props.locationOptionsByRegion[this.state.region?.id]}
              label={I18n.ac('medRecruiter.location')}
              value={this.state.clinicalLocation || null}
              onValue={this.handleInput.clinicalLocation}
              webMode={true}
            />
          </>
        )}
      </>
    );
  }

  // renderStep2() {
  //   if (!this.state.singlePagePatientForm && this.state.step !== 2) return null;
  //   const isStaff = this.state.status === MED_RECRUITER;
  //
  //   return (
  //     <>
  //       {!!isStaff && (
  //         <Select
  //           ref={roleRef}
  //           required={true}
  //           editable={true}
  //           closeOnSelect={true}
  //           options={this.props.rolesOptions}
  //           label={I18n.ac('staff.role')}
  //           value={
  //             this.state.role
  //               ? {
  //                   label: this.state.role,
  //                   id: this.state.role,
  //                 }
  //               : null
  //           }
  //           onValue={this.handleInput.role}
  //           webMode={true}
  //         />
  //       )}
  //     </>
  //   );
  // }

  render() {
    const props = this.props;
    return (
      <View style={[{ zIndex: 1000, paddingBottom: 30 }]}>
        {this.renderStep1()}
        {/*this.renderStep2()*/}
      </View>
    );
  }
}

const styles = StyleSheet.create({});

function mapStateToProps(state, ownProps) {
  const regionOptions = (state.entities.metaData.vaRegions || []).map((r) => ({
    id: r.id,
    label: r.name,
  }));

  let clinicalLocation = null;
  let selectedRegionId = null;
  const locationOptionsByRegion = Object.keys(ownProps.locationsByRegion || {}).reduce(
    (result, rId) => {
      result[rId] = ownProps.locationsByRegion[rId].map((l) => ({
        id: l.clinical_location_id,
        label: l.name,
      }));
      const selectedOption = result[rId].find(
        (o) => o.id === ownProps.editingCase?.clinical_location_id
      );
      if (selectedOption) {
        clinicalLocation = selectedOption;
        selectedRegionId = rId;
      }
      return result;
    },
    {}
  );

  const region = selectedRegionId ? regionOptions.find((o) => o.id == selectedRegionId) : null;

  return {
    patient: ownProps.editingCasePatient,
    regionOptions,
    locationOptionsByRegion,
    clinicalLocation,
    region,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({}, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
  CreatePersonFormMR
);
